// extracted by mini-css-extract-plugin
export default {"trigger":"Sentencing_trigger__75+9p","triggerLabel":"Sentencing_triggerLabel__UuaUc","infoIcon":"Sentencing_infoIcon__bKAJ4"};